import { Button, Form, Modal } from "react-bootstrap";

type Props = {
  show: boolean;
  handleClose: () => void;
  handleSubmit: () => void;
};

const FavOrderModal: React.FC<Props> = ({
  show,
  handleClose,
  handleSubmit,
}) => {
  return (
    <>
      <Modal
        className="order_option_popup"
        show={show}
        onHide={handleClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add To Favorite</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>Email address</Form.Label>
            <Form.Control
              type="text"
              placeholder="Name your favourite order"
              autoFocus
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleSubmit}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default FavOrderModal;
